import { encodeURL } from '~/utils/helper/cyoHelper';
import { encodeURLNew } from '~/utils/helper/cyoHelper';

export default {

        init( context ){
            
            this.route = context.routeInstance
            this.router = context.routerInstance            
            this.context        = context
            this.fAttributes    = context.getSettingAllFilter()
            this.fArray         = context.getSettingAllFilterOptions()
        },

        cleanLabels(str) {

            return str.replace(this.moduleType + ' ', '').replace(' ', '')
        },
        cleanMetal(str) {

            return str.replace('Price-', '').split(' ').map((cv) => this.ucFirst(cv)).join('')
        },
        validateNumericRange(input, range) {

            return input >= range.min && input <= range.max
        },
        getFilter(name) {
            // console.log('getFilter ', name, this.filters.find((cv) => cv.name === name))
            return this.fAttributes.find((cv) => cv.name === name)
        },
        isSliderChanged(range) {
            return (range.from !== range.min || range.to !== range.max)
        },
        attachCurrency() {

            if (!import.meta.client) {

                return
            }

            // let cartModule = JSON.parse(localStorage.getItem('cartModule'))

            // if (cartModule.currency && ['USD', 'EUR', 'GBP'].includes(cartModule.currency) && cartModule.currency !== 'USD') {

            //     this.payloads.currency = cartModule.currency
            // }

        },
        async updateUrlHistory( data ) {
            
            if ( import.meta.server ) {

                return 
            }

            let modPayload = { ...this.payloads }

            // Ensure modPayload and its properties are valid before processing
            if (modPayload?.CaratFrom === 1 && modPayload?.CaratTo === this?.fArray?.carat?.max) {
                delete modPayload.CaratFrom;
                delete modPayload.CaratTo;
            }

            // Ignore clarity filter if 'from' is VS1 and 'to' is FL
            if (
                Array.isArray(modPayload?.Clarity) && 
                modPayload.Clarity.length > 0 && 
                modPayload.Clarity[0] === 'VS2' && 
                modPayload.Clarity[modPayload.Clarity.length - 1] === 'FL'
            ) {
                delete modPayload.Clarity;
            }

            // Ignore color filter if 'from' is I and 'to' is D
            if (
                Array.isArray(modPayload?.Color) && 
                modPayload.Color.length > 0 && 
                modPayload.Color[0] === 'G' && 
                modPayload.Color[modPayload.Color.length - 1] === 'D'
            ) {
                delete modPayload.Color;
            }

            // Ignore cut filter if 'from' is GD and 'to' is ID
            if (
                Array.isArray(modPayload?.Cut) && 
                modPayload.Cut.length > 0 && 
                modPayload.Cut[0] === 'GD' && 
                modPayload.Cut[modPayload.Cut.length - 1] === 'ID'
            ) {
                delete modPayload.Cut;
            }


            const search = encodeURLNew(modPayload)
            
            if(data.unsetStartWith &&  this.route.params && this.route.params.start_with ){

                const newRoute = this.router.resolve({ name: this.route.name, query: search, params:{ start_with: undefined }  });

                return await this.router.push(newRoute)
            }

            if( Object.keys(this.payloads).length === 0 && Object.keys(this.route.query).length > 0 ){

                return await this.router.push({ query : {} })
            }

            if( Object.keys(this.payloads).length > 0 ){

                await this.router.push({  query: search });
            }


        },
        clearStartWith() {
            
            return
            if (import.meta.client) {

               
            }

        },

        setRequestPayload( data ) {
            
            // console.log(  'setRequestPayload start_with', this.route.params, this.route.params.start_with)
            
            if (this.route.params.start_with && data.unsetStartWith) {

                // this.clearStartWith()
            }
            this.payloads = {}

            const filterTags = []

            // loop all filter attributes shape, metal, styles 

            for (let i = 0; i < this.fAttributes.length; i++) {

                const fA = this.fAttributes[i]

                if(!this.fArray || !this.fArray[fA.name]  ){
                    
                    continue
                }

                // check single select
                if (fA.type === 'select' && fA.singleSelect) {

                    // find active filter and it is not default selection
                    const activeOption = this.fArray[fA.name].find((o) => o.active === 1 && fA.default !== o.value)

                    if (activeOption) {

                        // add it in payload
                        this.payloads[fA.urlLabel] = activeOption.url
                    }

                    if (activeOption) {

                        filterTags.push( { option : activeOption, filter : fA } )
                    }
                }


                // multi select

                if (fA.type === 'select' && !fA.singleSelect) {
                                            // console.log('this.fAttributes',fA.name,fA,this.fArray)

                    const activeArray = this.fArray[fA.name].filter((c) => c.active === 1).map((c) => c.url)
                    const activeArrayTags = this.fArray[fA.name].filter((c) => c.active === 1).map(c =>  ({ option : c, filter : fA }) )
                    if (activeArray.length) {

                        this.payloads[fA.urlLabel] = activeArray

                        filterTags.push(  ...activeArrayTags )
                    }
                    
                }   
                

                if (fA.type === 'select_group' && fA.singleSelect) {

                    this.fArray[fA.name].map((c) => {

                        const select_group_active = c.options.find((cv) => cv.active == 1)

                        if (select_group_active && select_group_active.value !== fA.default) {

                            this.payloads[fA.urlLabel] = select_group_active.url
                        }
                    })
                }


                // slider
                if (fA.type == 'slider') {

                    if (!this.isSliderChanged(this.fArray[fA.name])) {

                        continue
                    }

                    // slider is changed, set payload accoringly
                    if (fA.config.type === 'alpha') {

                        // get all label values
                        const values = this.fArray[fA.name].values

                        this.payloads[fA.urlLabel] = values.slice(this.fArray[fA.name].from, this.fArray[fA.name].to)
                    }

                    if (fA.config.type === 'num') {

                        const from  = this.fArray[fA.name].from
                        const to    = this.fArray[fA.name].to

                        this.payloads[fA.urlLabel + 'From'] = from
                        this.payloads[fA.urlLabel + 'To']   = to

                        filterTags.push( { option : { from: from, to : to, value : from+"___"+to }, filter : fA } )                                            

                    }
                }

                // slider
                if (fA.type == 'checkbox') {

                    const activeArray = this.fArray[fA.name].filter((c) => c.active === 1).map((c) => c.url)
                    if (activeArray.length) {

                        this.payloads[fA.urlLabel] = activeArray
                    }
                    // console.log(activeArray)

                }

            }
            // console.log('this.payloads', this.payloads)

            // console.log('data.updateURLHistory',data,data.updateURLHistory)
            if( data.updateURLHistory ){

                this.updateUrlHistory( data )
            }


            this.payloads.page = 1

            return {payload: this.payloads, filterTags}
        },


        setSelectOptions(data) {

            // start loop on filter property
            this.fArray[data.type.name] = this.fArray[data.type.name].map((cv) => {

                // if it is single select then we start with disbling others
                if (data.type.singleSelect) {

                    cv.active = 0
                }
                // console.log('beforeChange',cv.value, data.value.value, cv.active)
                // now we match and activate user selection
                // console.log('afterChange',cv.value, data.value.value, cv.active, cv.value === data.value.value)

                if (cv.value === data.value.value) {
                    // bad code
                    cv.active = (cv.active === 1) ? 0 : 1
                }
                // console.log('afterChange',cv.value, data.value.value, cv.active)
                return cv
            })
        },

        setFiltersFromRoute() {

            // console.log(this.fAttributes)

            for (let i = this.fAttributes.length - 1; i >= 0; i--) {
                // console.log(this.fAttributes[i].type)
                // debugger
                // activate sliders
                if (this.fAttributes[i].type == 'slider') {

                    this.setSliderFromUrl(this.fAttributes[i])
                }

                // activate select options

                if (this.fAttributes[i].type == 'select' || this.fAttributes[i].type == 'checkbox') {

                    this.setDropdownFromUrl(this.fAttributes[i])
                }
            }
        },

        setSliderFromUrl(fA) {

            if (fA.config.type == 'num') {

                let from = this.route.query[fA.urlLabel + 'From']

                if (!isNaN(from) && this.validateNumericRange(from, this.fArray[fA.name])) {

                    this.fArray[fA.name].from = from
                }

                let to = this.route.query[fA.urlLabel + 'To']

                if (!isNaN(from) && this.validateNumericRange(to, this.fArray[fA.name])) {

                    this.fArray[fA.name].to = to
                }
            }

            if (fA.config.type == 'alpha') {

                if (!this.route.query[fA.urlLabel]) {

                    return
                }

                let inputs = this.route.query[fA.urlLabel].split(',')

                let values = this.fArray[fA.name].values

                /*validate and select the values from url, we will receive it in ordered set*/
                let filterInputs = values.filter((value) => inputs.includes(value));

                if (filterInputs.length > 0) {

                    this.fArray[fA.name].from = values.indexOf(filterInputs[0])

                    /*get the last element, array key + 1*/
                    this.fArray[fA.name].to = values.indexOf(filterInputs[filterInputs.length - 1]) + 1
                }

                //to keep 1 step gap between the slider range
                if (this.fArray[fA.name].from === this.fArray[fA.name].to) {

                    this.fArray[fA.name].to = this.fArray[fA.name].from + 1;
                }

            }


        },

        setDropdownFromUrl(fAttr) {

            if (!this.route.query[this.cleanLabels(fAttr.urlLabel)]) {

                return;
            }

            // perform validation and get all values from url 
            const urlValues = this.route.query[this.cleanLabels(fAttr.urlLabel)].split(',')

            // not required but better to have it
            if (urlValues.length > 30) {

                return
            }

            // console.log(urlValues, expectedValue)
            for (let j = urlValues.length - 1; j >= 0; j--) {

                // find in our values
                let option = this.fArray[fAttr.name].find((cv) => cv.url === urlValues[j])

                // if yes then activate the selection
                if (option) {

                    // console.log( { type: fAttr, value: {value: urlValues[j] }})
                    // if it real and present in our array, we will activate it
                    this.setSelectOptions({ type: fAttr, value: option })
                }

            }

        },


        validateUrlParam(){

            const start_with = this.route.params.start_with

            if (! start_with) {

                return true
            }

            const locale = this.context.$i18n.locale


            if ( this.route.name === `cyo-diamond-list-ring___${locale}` ) {

                const shapes = ['round-rings', 'pear-rings', 'oval-rings', 'emerald-rings', 'cushion-rings', 'princess-rings', 'radiant-rings', 'heart-rings', 'asscher-rings', 'marquise-rings']

                return shapes.includes(start_with) ? true : false
            }

            if ( this.route.name === `shop-all___${locale}` && !this.context.$country.is_india ) {

                const gifts = ['gifts-under-1000', 'gifts-under-2000', 'gifts-under-3000']

                return gifts.includes(start_with) ? true : false
            }

            if ( this.route.name === `shop-all___${locale}` && this.context.$country.is_india) {

                const gifts = ['gifts-under-50000', 'gifts-under-80000', 'gifts-under-100000']

                return gifts.includes(start_with) ? true : false
            }


            if ( this.route.name === `cyo-setting-list-ring___${locale}` ) {

                const settingMetals = [
                    'white-gold-engagement-rings',
                    'yellow-gold-engagement-rings',
                    'rose-gold-engagement-rings',
                    'platinum-engagement-rings'
                ]

                const styles = [
                    'solitaire-engagement-rings',
                    'three-stone-engagement-rings',
                    'side-stone-engagement-rings',
                    'halo-engagement-rings',
                    'vintage-engagement-rings'
                ]


                return settingMetals.includes(start_with) || styles.includes(start_with)   ? true : false
            }

            


            // console.log( this.route.name, 'this.route.name')
            return true

        },


        setFiltersFromUrl() {

            if (! this.route.params.start_with) {

                this.setFiltersFromRoute()

            }

            // console.log( 'this.setFiltersFromRoute()', this.fArray )

            // return

            const start_with = this.route.params.start_with

            const settingMetals = { 
                'white-gold-engagement-rings': '14kt_white_gold',
                'yellow-gold-engagement-rings': '14kt_yellow_gold',
                'rose-gold-engagement-rings' : '14kt_rose_gold',
                'platinum-engagement-rings':'platinum',

                // shop wedding bands
                'white-gold-wedding-bands': '14kt_white_gold',
                'yellow-gold-wedding-bands': '14kt_yellow_gold',
                'rose-gold-wedding-bands' : '14kt_rose_gold',
                'platinum-wedding-bands':'platinum'
            }


            if ( Object.keys( settingMetals ).includes( start_with ) ) {

                let fAttr = this.getFilter('metal')
                
                let option = this.fArray.metal.find((cv) => cv.value === settingMetals[start_with])

                if (option) {

                    this.setSelectOptions({ type: fAttr, value: option })
                }

                return
            }
            

            // start with style
            const styles = [
                'solitaire-engagement-rings',
                'three-stone-engagement-rings',
                'side-stone-engagement-rings',
                'halo-engagement-rings',
                'vintage-engagement-rings'
            ]

            // cyo
            if (styles.includes(start_with)) {

                let fAttr = this.getFilter('style')

                let option = this.fArray.style.find((cv) => {

                    return cv.value === start_with.replace('-engagement-rings', '').split('-').join('_')
                })
                if (option) {

                    this.setSelectOptions({ type: fAttr, value: option })
                }

                return
            }


            // webshop start with
            const subtype = [ 'full-eternity', 'couple-bands', 'band', 'womens-wedding-rings']

            // cyo
            if (subtype.includes(start_with)) {

                let fAttr = this.getFilter('subtype')
               
                let option = this.fArray.subtype.find((cv) => {

                    return cv.value === start_with
                })
                if (option) {

                    this.setSelectOptions({ type: fAttr, value: option })
                }

            }



            // diamonds start with

            const looseShapes = ['round-cut-diamond', 'pear-cut-diamond', 'oval-cut-diamond', 'emerald-cut-diamond', 'cushion-cut-diamond', 'princess-cut-diamond', 'radiant-cut-diamond', 'heart-cut-diamond', 'asscher-cut-diamond', 'marquise-cut-diamond']

            // loose
            if (looseShapes.includes(start_with)) {

                let fAttr = this.getFilter('shape')

                let option = this.fArray.shape.find((cv) => cv.value === start_with.replace('-cut-diamond', '').split('-').join('_'))

                if (option) {

                    this.setSelectOptions({ type: fAttr, value: option })
                }

                return 
            }


            const shapes = ['round-rings', 'pear-rings', 'oval-rings', 'emerald-rings', 'cushion-rings', 'princess-rings', 'radiant-rings', 'heart-rings', 'asscher-rings', 'marquise-rings']

            // cyo
            if (shapes.includes(start_with)) {

                let fAttr = this.getFilter('shape')

                let option = this.fArray.shape.find((cv) => cv.value === start_with.replace('-rings', '').split('-').join('_'))

                if (option) {

                    this.setSelectOptions({ type: fAttr, value: option })
                }

                return
            }


            if (start_with === 'quick-shipped') {

                let fAttr = this.getFilter('quickship')
                let option = this.fArray.quickship.find((cv) => cv.value === 'yes')
                if (option) {
                    this.setSelectOptions({ type: fAttr, value: option })
                }
                return
            }

            if (start_with === 'gia-certified') {

                let fAttr = this.getFilter('report')
                let option = this.fArray.report.find((cv) => cv.value === 'gia')
                if (option) {
                    this.setSelectOptions({ type: fAttr, value: option })
                }
                return
            }

            if (start_with === 'igi-certified') {

                let fAttr = this.getFilter('report')
                let option = this.fArray.report.find((cv) => cv.value === 'igi')
                if (option) {
                    this.setSelectOptions({ type: fAttr, value: option })
                }
                return
            }


        }

    
}